import { Paper as MuiPaper, PaperProps } from '@mui/material';
import clsx from 'clsx';
import React from 'react';

interface CustomPaperProps extends PaperProps {
  transparent?: boolean;

  marginBottom?: number;
  marginTop?: number;
}

const Paper: React.FC<CustomPaperProps> = ({ transparent, className, marginBottom, marginTop, sx, ...props }) => {
  return (
    <MuiPaper
      {...props}
      sx={{
        mt: marginTop,
        mb: marginBottom,
        ...sx,
      }}
      className={clsx(className, {
        transparent: transparent,
      })}
    />
  );
};

export default Paper;
